/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2024) Takeda. All Rights Reserved
 */

export const MS_IN_S = 1000;
export const S_IN_MIN = 60;
export const MS_IN_MIN = MS_IN_S * S_IN_MIN;
